
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Container from '@mui/material/Container';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import { MenuItem } from '@mui/material';
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import 'react-toastify/dist/ReactToastify.css';
import { toast } from 'react-toastify';
import Package from '../../models/package';

const CreatePackage = (props) => {
  const navigate = useNavigate();
  const [error, setError] = useState('');
  const [errors, setErrors] = useState({});
  const [status, setStatus] = useState('ACTIVE');

  const statusOptions = [
    { value: 'ACTIVE', label: 'Hoạt động' },
    { value: 'INACTIVE', label: 'Không hoạt động' }
  ];

  const handleSubmit = async (event) => {
    event.preventDefault();
    const data = new FormData(event.currentTarget);

    let validationErrors = {};
    if (!data.get('name')) validationErrors.name = 'Tên gói không được để trống';
    if (!data.get('status')) validationErrors.status = 'Trạng thái không được để trống';

    const amountValue = data.get('amount');
    if (!amountValue || isNaN(parseFloat(amountValue))) {
      console.log(data)
      console.log('amout', amountValue)
      validationErrors.amount = 'Số lượng không hợp lệ';
    }
    if (!data.get('limit_delivery') || isNaN(data.get('limit_delivery'))) validationErrors.limit_delivery = 'Giới hạn giao hàng phải là số';
    if (!data.get('price') || isNaN(data.get('price'))) validationErrors.price = 'Giá không hợp lệ';
    if (!data.get('interval') || isNaN(data.get('interval'))) validationErrors.interval = 'Khoảng thời gian phải là số';

    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
      return;
    }

    const packageData = new Package({
      name: data.get('name'),
      status: data.get('status'),
      amount: parseFloat(data.get('amount')),
      limit_delivery: parseInt(data.get('limit_delivery')),
      price: parseInt(data.get('price')),
      interval: parseInt(data.get('interval'))
    });

    try {
      const response = await packageData.createPackage();
      if (response.success) {
        toast.success(response.message, {
          position: "top-center",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
        });
        navigate('/packages');
      } else {
        setError(response.message);
      }
    } catch (error) {
      console.error("API Error:", error);
      toast.error("Đã xảy ra lỗi khi tạo gói dịch vụ", {
        position: "top-center",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
      });
    }
  };

  return (
    <>
      <Container maxWidth="xs" sx={{ mt: 3 }}>
        <Box component="form" onSubmit={handleSubmit} noValidate sx={{ mt: 1 }}>
          <TextField
            margin="normal"
            required
            fullWidth
            id="name"
            label="Tên gói dịch vụ"
            name="name"
            autoComplete="name"
            error={!!errors.name}
            helperText={errors.name}
          />
          <TextField
            margin="normal"
            required
            fullWidth
            select
            id="status"
            label="Trạng thái"
            name="status"
            value={status}
            onChange={(e) => setStatus(e.target.value)}
            error={!!errors.status}
            helperText={errors.status}
          >
            {statusOptions.map((option) => (
              <MenuItem key={option.value} value={option.value}>
                {option.label}
              </MenuItem>
            ))}
          </TextField>
          <TextField
            margin="normal"
            required
            fullWidth
            id="amount"
            name="amount"
            label="Số lượng"
            type="number"
            step="0.01"
            inputProps={{ min: "0", step: "0.01" }}
            error={!!errors.amount}
            helperText={errors.amount}
          />
          <TextField
            margin="normal"
            required
            fullWidth
            id="limit_delivery"
            label="Giới hạn giao hàng"
            name="limit_delivery"
            type="number"
            error={!!errors.limit_delivery}
            helperText={errors.limit_delivery}
          />
          <TextField
            margin="normal"
            required
            fullWidth
            id="price"
            label="Giá (VNĐ)"
            name="price"
            type="number"
            error={!!errors.price}
            helperText={errors.price}
          />
          <TextField
            margin="normal"
            required
            fullWidth
            id="interval"
            label="Khoảng thời gian (ngày)"
            name="interval"
            type="number"
            error={!!errors.interval}
            helperText={errors.interval}
          />
          <Typography sx={{ textAlign: "center", mt: 2, mb: 2 }} color="error">{error}</Typography>
          <Button
            type="submit"
            fullWidth
            variant="contained"
            sx={{ mt: 3, mb: 2 }}
          >
            Tạo mới
          </Button>
        </Box >
      </Container >
    </>
  );
};

export default CreatePackage;
